import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

/**
 * PublicRoute — Guards auth pages (login, register, etc.)
 * Redirects to /home if user is already authenticated.
 * Prevents logged-in users from seeing login/register screens.
 *
 * @param {React.ReactNode} children — The public page component
 */
const PublicRoute = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.auth);

  const hasToken = localStorage.getItem("mango_access_token");
  const isStoredAuth = localStorage.getItem("mango_authenticated") === "true";

  if (isAuthenticated || hasToken || isStoredAuth) {
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default PublicRoute;
